import { BMDotLoader, BMPrimitives } from "@traveloka/district-bloom";
import { ComponentProps } from "react";
import { StyleSheet } from "react-native";
import { ErrorSection } from "../../../../components";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { FlightRefundInfos } from "../../Flight/FlightRefundInfos";

type Props = {
  refundInfos: ComponentProps<typeof FlightRefundInfos>["refundInfos"] | null;
  isLoading: boolean;
  onRetry: () => void;
};

export default function FlightPrebookRefundInfos({
  refundInfos,
  isLoading,
  onRetry,
}: Props) {
  const { CorporateGeneralErrorMessage: cr } = useMobileContentResource();

  if (isLoading) {
    return (
      <BMView flex justify="center" align="center">
        <BMDotLoader />
      </BMView>
    );
  }

  if (!refundInfos) {
    return (
      <ErrorSection
        type="LARGE"
        button={{ label: cr.fullPageCTA, onPress: onRetry }}
      />
    );
  }

  return (
    <BMView style={styles.container}>
      <FlightRefundInfos refundInfos={refundInfos} />
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: BMPrimitives.BMSize.md,
  },
});
